import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons, Button } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import SelectInput from '../../../components/fields/SelectInput/SelectInput';

export default function PaymentLogFilterForm(props) {
  const {
    onHide, control, getValues, reset, defaultValues, paymentListMeta, typePaymentOptions, methodPaymentOptions,
  } = props;
  const navigate = useNavigate();

  const handleRemoveParams = () => {
    const cleanUrl = window.location.pathname;
    navigate(cleanUrl, { replace: true });
  };

  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#filter-scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      preventDefault: false,
      interactiveScrollbars: true,
    });
    setScroll(a);
  }, []);

  const clear = () => {
    reset({ ...getValues(), ...defaultValues });
    handleRemoveParams();
  };

  const save = () => {
    localStorage.setItem('plp-filter', JSON.stringify({ ...getValues() }));
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">Фильтры</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={onHide} />
            </div>
          </>
      )}
      />
      <DialogContent className="hff-content">
        <div className="scroll-wrapper filter-scroll-wrapper" id="filter-scroll-wrapper">
          <div className="scroll">
            <form>
              <FieldDTO
                type="text"
                component={TextInputWithLabel}
                placeholder="Начните печатать для поиска"
                dtoObject={{
                  name: 'session_id',
                  type: String,
                  validators: [],
                  labelKey: 'plp.session_id',
                }}
                control={control}
              />
              <FieldDTO
                type="text"
                dtoObject={{
                  name: 'host_name',
                  type: String,
                  validators: [],
                  labelKey: 'plp.hostName',
                }}
                control={control}
                component={TextInputWithLabel}
                options={typePaymentOptions}
                className="filter-margin"
                withLabel
                addPlaceholder
              />
              <FieldDTO
                type="text"
                dtoObject={{
                  name: 'method',
                  type: String,
                  validators: [],
                  labelKey: 'plp.paymentMethod',
                }}
                control={control}
                withLabel
                addPlaceholder
                component={SelectInput}
                options={methodPaymentOptions}
                className="filter-margin"
              />
              <FieldDTO
                type="text"
                control={control}
                dtoObject={{
                  name: 'type',
                  type: String,
                  validators: [],
                  labelKey: 'plp.paymentType',
                }}
                withLabel
                addPlaceholder
                component={SelectInput}
                options={typePaymentOptions}
                className="filter-margin"
              />
              <FieldDTO
                type="text"
                component={TextInputWithLabel}
                control={control}
                dtoObject={{
                  name: 'masked_pan',
                  type: String,
                  validators: [],
                  labelKey: 'plp.masked_pan',
                }}
                className="filter-margin"
              />
              <FieldDTO
                type="text"
                component={TextInputWithLabel}
                placeholder="Начните печатать для поиска"
                dtoObject={{
                  name: 'rrn',
                  type: String,
                  validators: [],
                  labelKey: 'plp.rrn',
                }}
                control={control}
                className="filter-margin"
              />
              <FieldDTO
                type="text"
                component={TextInputWithLabel}
                control={control}
                dtoObject={{
                  name: 'auth_code',
                  type: String,
                  validators: [],
                  labelKey: 'plp.auth_code',
                }}
                className="filter-margin"
              />
              <div className="empty" />
            </form>
          </div>
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-text">Найдено {paymentListMeta.total} платежей</div>
        {/* {meta && meta.total ? meta.total : 0} */}
        <div className="hff-footer-buttons">
          <Button className="hff-clear-show" onClick={save}>Показать</Button>
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>Сбросить всё</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
